export default __webpack_public_path__ + "static/media/ilac_mra.77546635.png";